// src/i18n/en/index.js
import raEnglishMessages from 'ra-language-english'; // Cambio aquí - sin destructuring

// Importar traducciones modulares - Fix de imports
import { zones } from './zones'; // Importar como named export
import { tagTypes } from './tagTypes'; // Importar como named export
import lockerTypes from './lockerTypes'; // Importar lockerTypes
import hotels from './hotels'; // Importar hotels
import groups from './groups'; // Importar groups
import hmis from './hmis'; // Importar hmis
import lockerControllers from './lockerControllers'; // Importar lockerControllers
import lockers from './lockers'; // Importar lockers
import { lockerAssignments } from './lockerAssignments'; // Importar lockerAssignments
import common from './common'; // Importar common
import dashboard from './dashboard'; // Importar dashboard
import users from './users'; // Importar users
import auth from './auth'; // Importar auth
import tags from './tags'; // Importar tags
import hmiSimulator from './hmiSimulator'; // Importar hmiSimulator

const en = {
  ...raEnglishMessages, 
  ra: {
    ...raEnglishMessages.ra,
    action: {
      ...raEnglishMessages.ra.action,
      add_filter: 'Add filter',
      more: 'More actions',
      menu: 'Menu',
      clear_input_value: 'Clear field',
      close: 'Close',
      none: 'None'
    },
    auth: {
      ...raEnglishMessages.ra.auth,
      sign_in_error: 'Sign in error. Please check your credentials.',
      logging_in: 'Signing in...',
    },
    navigation: {
      ...raEnglishMessages.ra.navigation,
      page_rows_per_page: 'Rows per page:',
      page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
      page_out_of_boundaries: 'Page number %{page} out of boundaries',
      page_out_from_end: 'Cannot go after last page',
      page_out_from_begin: 'Cannot go before page 1',
      page_empty: 'No records',
      next: 'Next',
      prev: 'Previous',
      page_info: '%{from}-%{to} of %{count}',
      page_rows_per_page_all: 'All',
      partial_page_range_info: '%{offsetBegin}-%{offsetEnd} of %{total}',
      page_range: '%{from}-%{to} of %{count}',
      displayed_records: '%{from}-%{to} of %{count}',
    },
    pagination: {
      page_info: '%{from}-%{to} of %{count}',
      page_info_simple: 'Page %{page}',
      labeled_page_info: '%{from}-%{to} of %{count}',
    },
    page: {
      ...raEnglishMessages.ra.page,
      not_found: 'Page not found',
      dashboard: 'Dashboard',
      create: 'Create',
      edit: 'Edit',
    },
    message: {
      ...raEnglishMessages.ra.message,
      not_found: 'The requested resource was not found',
      delete_title: 'Confirm deletion',
      delete_content: 'Are you sure you want to delete this item?',
      invalid_form: 'The form contains errors. Please review the fields',
    },
    notification: {
      ...raEnglishMessages.ra.notification,
      deleted: 'Element deleted',
    },
  },
  fields: {
    hotel: 'Hotel',
    zone: 'Zone',
    name: 'Name',
    description: 'Description',
    status: 'Status',
    active: 'Active',
    type: 'Type',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    city: 'City',
    country: 'Country',
    createdAt: 'Created at',
    updatedAt: 'Last updated',
    lastSeenAt: 'Last connection',
    isOnline: 'Online',
  },
  common,
  resources: {
    lockers,
    locker_assignments: lockerAssignments,
    users: users,
    hotels: hotels,
    groups: groups,
    tags: tags,
    settings: {
      name: 'Setting |||| Settings',
    },
    tag_types: {
      name: 'Tag Type |||| Tag Types',
    },
    locker_controllers: lockerControllers,
    hmis,
    locker_types: {
      name: 'Locker Type |||| Locker Types',
    },
    hmi_simulator: {
      name: 'HMI Simulator |||| HMI Simulators',
    },
    'tag-types': tagTypes,
    'locker-controllers': lockerControllers,
    'locker-types': lockerTypes,
    'locker-assignments': lockerAssignments,
    'hmi-simulator': {
      name: 'HMI Simulator |||| HMI Simulators',
    },
    zones: zones || {}, // Fallback si no existe
    tagTypes: tagTypes || {}, // Fallback si no existe
    dashboard: dashboard,
  },
  dashboard,
  users,
  auth,
  hmiSimulator,
  user: {
    profile: 'Profile',
    settings: 'Settings',
    change_password: 'Change Password',
  },
  pages: {
    login: {
      subtitle: 'Sign in to start',
      login_button: 'Sign In',
    },
    dashboard: {
      no_devices: 'No results found',
      no_devices_description: 'No data available at this time',
    },
  },
};

export default en;